/** @format */

export default {
	SET_CARD_READER_STATS: 'SET_CARD_READER_STATS',
	SET_ERROR_FOR_CARD_READER_STATS: 'SET_ERROR_FOR_CARD_READER_STATS',
	SET_READERS: 'SET_READERS',
	SET_ERROR_FOR_CARD_READERS: 'SET_ERROR_FOR_CARD_READERS',
};
